<div class="sliderBody" id="sliderBody">

  <div class="item" *ngFor="let item of items; let i = index">
    <img src="{{httpHelperService.imageUrl}}?referenceId={{item.Id}}&referenceTypeId=22&saasProfileId=3176"  matTooltip="{{item.ItemName}}"/>
    <span class="itemsCount">
      {{item.Quantity}}
    </span>
    <div class="cartItemsControl">
      <i class="minus fas fa-minus-circle fa-fw" (click)="decreaseQuantity(item)"></i>
      <i class="plus fas fa-plus-circle fa-fw" (click)="increaseQuantity(item)"></i>
    </div>
    <div class="cartItemsRemove" (click)="removeItem(item)">
      <i class="fas fa-times"></i>
    </div>
  </div>
</div>

